module.exports = __webpack_public_path__ + "img/collection-weddingRingsFancy.281bfd8.webp";